import * as yup from 'yup';
import i18n from 'config/i18n';

import { BlockedTerm, MentionObject, Network } from 'api/public';

import { PublicContentCommentary, Variations } from './types';
import { blockListSchema } from 'features/sharing/validations';

const publicContentMessagesSchema = yup.object<PublicContentCommentary>({
  commentary: yup
    .string()
    .test('blockList', i18n.t('sharing:blocklistWarning'), (value, testContext) => {
      const { blockList } = testContext.parent;
      if (!blockList || !blockList.length || !value) {
        return true;
      }
      const hasBlockedTerms = blockList.some(({ term }: BlockedTerm) => value.includes(term));
      return !hasBlockedTerms;
    }),
  mentions: yup
    .array()
    .of(
      yup.object<MentionObject>({
        identifier: yup.string(),
        length: yup.number(),
        provider: yup.string(),
        start: yup.number(),
      })
    )
    .nullable(true),
  network: yup
    .mixed<Network>()
    .oneOf([
      Network.Facebook,
      Network.Instagram,
      Network.Linkedin,
      Network.Twitter,
      Network.Msteams,
      Network.Slack,
      Network.Xing,
    ]),
  blockList: blockListSchema,
});

export const publicSharingSchema = yup.object<Variations>({
  index: yup.number(),
  messages: yup.array().of(publicContentMessagesSchema),
});
